import React, { useState } from "react";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import {selectAuthLoading} from "../../../store/selectors/Auth";
import {useSelector} from "react-redux";
import TextBox from '../../Common/Textbox/large'
import Button from '../../Common/Buttons'

const loginSchema = Yup.object().shape({
  password: Yup.string()
    .min(8, "The password must have 8 character at least!")
    .max(50, "The password must be no more than 8 characters long!")
    .required("Password is required"),
  email: Yup.string()
    .trim()
    .email("Please enter a valid email")
    .required("Email is required")
});

const AuthForm = ({ handleSubmit, children, submitText, referrer }) => {
  
  const [showPassword, setShowPass] = useState(false);
  const loading = useSelector(selectAuthLoading);

  const handleClickShowPassword = () => {
  
    setShowPass(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (
    <Formik
      initialValues={{ email: "", password: "", referrer: referrer }}
      validationSchema={loginSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, handleChange }) => {
        return (
          <Form className={"form"}>
            <div className={"inputContainer"}>
              
              <TextBox type={"text"} handleChange={handleChange} tName={"email"} label={"Email"} additionClass={''} htmlFor="filled-adornment-email" />
              <ErrorMessage className="error" name="email" component="div" />
            </div>
            <div className={"inputContainer"}>
              <TextBox type={showPassword ? 'text' : 'password'} handleChange={handleChange} tName={"password"} label={"Password"} additionClass={''}
               htmlFor="filled-adornment-password"  endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              } />
               
               

              <ErrorMessage className="error" name="password" component="div" />
            </div>
            { children }
            <Button loading={loading} additionClass={"EMPHASIS_EXTRA_DOUBLE_LARGE"} text={submitText} />
          </Form>
        );
      }}
    </Formik>
  );
}

export default AuthForm;
